import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="h1" components={components}>{`Advanced`}</MDXTag>
      <MDXTag name="h2" components={components}>{`Server-Side Rendering`}</MDXTag>
      <MDXTag name="p" components={components}>{`Rebass works with server-side rendering in both styled-components and emotion.`}</MDXTag>
      <MDXTag name="h3" components={components}>{`Styled Components`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-js"
        }}>{`const React = require('react')
const { renderToString } = require('react-dom/server')
const { ServerStyleSheet } = require('styled-components')
const App = require('./App')

module.exports = (req, res) => {
  const sheet = new ServerStyleSheet()
  const body = renderToString(
    sheet.collectStyles(
      React.createElement(App)
    )
  )
  const css = sheet.getStyleTags()

  // handle response...
}
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`Read more in the `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "https://www.styled-components.com/docs/advanced#server-side-rendering"
        }}>{`styled-components docs`}</MDXTag>{`.`}</MDXTag>
      <MDXTag name="h3" components={components}>{`Emotion`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-js"
        }}>{`const React = require('react')
const { renderToString } = require('react-dom/server')
const { renderStylesToString } = require('emotion-server')
const App = require('./App')

const html = renderStylesToString(
  renderToString(
    React.createElement(App)
  )
)
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`Read more in the `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "https://emotion.sh/docs/ssr"
        }}>{`emotion docs`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      